import React, { useState } from "react";
import { C } from "../theme";
import { fmt, Kpi, Btn, Inp, Sel, AdBanner } from "../shared";

export const EmployesPage = ({ employes, setEmployes, immId }) => {
  const [modal, setModal] = useState(false);
  const [form,  setForm]  = useState({nom:"",prenom:"",poste:"",tel:"",email:"",salaire:"",planning:"L-V 9h-18h"});
  const list = employes.filter(e => e.immId === immId);
  const save = () => {
    setEmployes(p => [...p, {id:Date.now(), immId, ...form, salaire:Number(form.salaire), statut:"actif", conges:0}]);
    setModal(false);
    setForm({nom:"",prenom:"",poste:"",tel:"",email:"",salaire:"",planning:"L-V 9h-18h"});
  };
  const statutColor = {actif:[C.green,"#d1fae5"], "congé":[C.gold,"#fffbeb"], absent:[C.red,"#fee2e2"]};
  const postes = ["Gardien","Gardienne","Femme de ménage","Technicien","Plombier","Électricien","Jardinier","Agent de sécurité"];
  const totalSalaires = list.reduce((a,e) => a + e.salaire, 0);
  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:22}}>
        <div>
          <h2 style={{fontSize:24,fontWeight:800,color:C.text}}>Gestion des Employés</h2>
          <p style={{color:C.muted,fontSize:13}}>{list.length} employés · Masse salariale : {fmt(totalSalaires)}/mois</p>
        </div>
        <Btn onClick={() => setModal(true)}>+ Ajouter un employé</Btn>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:20}}>
        <Kpi icon="👷" label="Total"         value={list.length}                               color={C.blue}   delay={0} />
        <Kpi icon="✅" label="Actifs"         value={list.filter(e=>e.statut==="actif").length} color={C.green}  delay={60} />
        <Kpi icon="🏖️" label="En congé"       value={list.filter(e=>e.statut==="congé").length} color={C.gold}   delay={120} />
        <Kpi icon="💵" label="Masse salariale" value={fmt(totalSalaires)}                       color={C.purple} delay={180} />
      </div>
      <AdBanner />
      <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:14}}>
        {list.map((e, i) => {
          const [sc, sb] = statutColor[e.statut] || [C.muted,"#f3f4f6"];
          return (
            <div key={e.id} className="fu ch" style={{animationDelay:`${i*60}ms`,background:C.card,borderRadius:16,padding:20,boxShadow:"0 2px 14px rgba(11,19,51,.06)"}}>
              <div style={{display:"flex",gap:14,alignItems:"flex-start"}}>
                <div style={{width:52,height:52,borderRadius:14,background:`linear-gradient(135deg,${C.teal}33,${C.blue}22)`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,fontWeight:700,color:C.teal,fontFamily:"Syne",flexShrink:0}}>
                  {(e.prenom||"?")[0]}{(e.nom||"?")[0]}
                </div>
                <div style={{flex:1}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                    <div>
                      <h4 style={{fontSize:14,fontWeight:700,color:C.text}}>{e.prenom} {e.nom}</h4>
                      <p style={{fontSize:12,color:C.muted,marginTop:2}}>{e.poste}</p>
                    </div>
                    <span style={{background:sb,color:sc,padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:700}}>{e.statut}</span>
                  </div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,marginTop:10}}>
                    {[["📞",e.tel],["📧",e.email],["🕐",e.planning],["💵",`${fmt(e.salaire)}/mois`]].map(([ic,v]) => (
                      <div key={ic} style={{display:"flex",gap:5,alignItems:"center"}}>
                        <span style={{fontSize:12}}>{ic}</span>
                        <span style={{fontSize:11,color:C.muted}}>{v}</span>
                      </div>
                    ))}
                  </div>
                  <div style={{display:"flex",gap:8,marginTop:12}}>
                    <button className="btn" onClick={() => {
                      const next = {actif:"congé","congé":"actif",absent:"actif"}[e.statut]||"actif";
                      setEmployes(p => p.map(x => x.id===e.id ? {...x,statut:next} : x));
                    }} style={{padding:"4px 10px",background:C.bg,color:C.muted,borderRadius:8,fontWeight:600,fontSize:11}}>🔄 Statut</button>
                    <button className="btn" onClick={() => setEmployes(p => p.filter(x => x.id!==e.id))}
                      style={{padding:"4px 10px",background:"#fee2e2",color:C.red,borderRadius:8,fontWeight:600,fontSize:11}}>🗑️</button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {modal && (
        <div className="ov" onClick={() => setModal(false)}>
          <div className="mb" onClick={e => e.stopPropagation()}>
            <h3 style={{fontSize:19,fontWeight:800,color:C.text,marginBottom:20}}>Ajouter un employé</h3>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
              <Inp label="Nom" value={form.nom} onChange={v => setForm({...form,nom:v})} />
              <Inp label="Prénom" value={form.prenom} onChange={v => setForm({...form,prenom:v})} />
            </div>
            <Sel label="Poste" value={form.poste} onChange={v => setForm({...form,poste:v})} options={postes} />
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
              <Inp label="Téléphone" value={form.tel} onChange={v => setForm({...form,tel:v})} />
              <Inp label="Salaire (MAD)" type="number" value={form.salaire} onChange={v => setForm({...form,salaire:v})} />
            </div>
            <Inp label="Planning" value={form.planning} onChange={v => setForm({...form,planning:v})} />
            <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:8}}>
              <Btn onClick={() => setModal(false)} outline>Annuler</Btn>
              <Btn onClick={save}>Enregistrer</Btn>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

/* ══════════════════════════════════════
   SYNDIC — DOCUMENTS
══════════════════════════════════════ */
